import Backoffice from './Backoffice/Backoffice'
import Cadastro from './Cadastro/Cadastro'
import Contratos from './Contrato/Contrato'
import Incoming from './Incoming/Incoming'
import Legacy from './Legacy/Legacy'
import Ocr from './Ocr/Ocr'
import Plans from './Plans/Plans'
import Auth from './Auth/Auth'

export default {
  Backoffice,
  Cadastro,
  Contratos,
  Incoming,
  Legacy,
  Ocr,
  Plans,
  Auth
}
